import { useEffect } from 'react';
import { useShallow } from 'zustand/shallow';
import { bootIntercom } from '@/lib/support/intercom';
import { useAuthStore } from '@/stores/use-auth-store';

/**
 * Deferred so the widget script never competes with app startup. Booting is
 * what puts platform and app version on the Intercom contact, so it happens
 * for every session rather than only when someone opens the messenger.
 */
const BOOT_DELAY_MS = 3000;

export function IntercomBridge() {
  const { nulaUserId, intercom } = useAuthStore(
    useShallow((s) => ({ nulaUserId: s.nulaUserId, intercom: s.intercom })),
  );

  useEffect(() => {
    if (!nulaUserId || !intercom) return;
    const id = window.setTimeout(() => {
      bootIntercom(intercom);
    }, BOOT_DELAY_MS);
    return () => window.clearTimeout(id);
  }, [nulaUserId, intercom]);

  return null;
}
